import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { SupplierProfile } from './Pages';

export const SupplierProfileRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}/:id?`} component={SupplierProfile} />
        
    </Fragment>
)